import { useQuery } from "@tanstack/react-query";
import { fetchProductsPerPage } from "./api/products";

export const useGetProducts = (page, genreID) => {
  return useQuery({
    queryKey: ["products", page, genreID],
    queryFn: () => fetchProductsPerPage(page, genreID),
  });
};
